var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.22217 5.5555C2.22217 5.09526 2.59526 4.72217 3.0555 4.72217H16.9444C17.4046 4.72217 17.7777 5.09526 17.7777 5.5555C17.7777 6.01574 17.4046 6.38883 16.9444 6.38883H3.0555C2.59526 6.38883 2.22217 6.01574 2.22217 5.5555Z",
    fill: "#71869D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38883 14.4444C6.38883 13.9842 6.76193 13.6111 7.22217 13.6111H12.7777C13.238 13.6111 13.6111 13.9842 13.6111 14.4444C13.6111 14.9046 13.238 15.2777 12.7777 15.2777H7.22217C6.76193 15.2777 6.38883 14.9046 6.38883 14.4444Z",
    fill: "#71869D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99995 9.16661C4.53971 9.16661 4.16661 9.53971 4.16661 9.99995C4.16661 10.4602 4.53971 10.8333 4.99995 10.8333H14.9999C15.4602 10.8333 15.8333 10.4602 15.8333 9.99995C15.8333 9.53971 15.4602 9.16661 14.9999 9.16661H4.99995Z",
    fill: "#71869D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/iconFilter.4999818a4cc9cb164ba8482ecca3ac22.svg";
export { ForwardRef as ReactComponent };